// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAk6jtWOYnOCiDoI379-G3b_FviW2CkUdk',
    authDomain: 'angular-community-meetup.firebaseapp.com',
    projectId: 'angular-community-meetup',
    storageBucket: 'angular-community-meetup.appspot.com',
    messagingSenderId: '1080600353619',
    appId: '1:1080600353619:web:5b778ee84216c28aa59fa6',
    measurementId: 'G-49SWTGJQ7F',
  },
  airtable: {
    apiKey:
      'patQwmFR8MAifZQNm.3e9a2e80403348a705643a423fef28cf7ac2596f4b97a0717e6bac9484f39cfd',
    base: 'appijSrXe31SWoWti',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
